import React, { useState } from "react";
import "./SetNewPass.css";
import { Container, Form } from "react-bootstrap";
import Logo from "../../Common-Component/Reset_Flow/Logo/Logo";
import Heading from "../../Common-Component/Reset_Flow/Heading/Heading";
import CommonText from "../../Common-Component/Reset_Flow/Common_Text/CommonText";
import Banner from "../../Common-Component/Reset_Flow/Banner/Banner";
import { Link, useLocation, useNavigate } from "react-router-dom";
import BrownSuccessFullModal from "../../Common-Component/Common_Modal/BrownSuccessFullModal/BrownSuccessFullModal";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PasswordChecklist from "react-password-checklist";
import { useDispatch } from "react-redux";
import { forgotPassword } from "../../../features/auth/authSlice";

export default function SetNewPass() {

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const [openSuccessModal, setOpenSuccessModal] = useState(false);

  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [iconOne, setIconOne] = useState(faEyeSlash);
  const [iconTwo, setIconTwo] = useState(faEyeSlash);

  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
      setIconOne(showPassword ? faEyeSlash : faEye);
    } else if (field === "reenterPassword") {
      setShowPasswordOne(!showPasswordOne);
      setIconTwo(showPasswordOne ? faEyeSlash : faEye);
    }
  };

  const navigate = useNavigate()

  const location = useLocation();
  const emailOrContact = location.state; // Retrieve data
  const dispatch = useDispatch();
 
  const onSubmit = async (data) => {
    data.email_or_contact=emailOrContact.email_or_contact;
    const res = await dispatch(forgotPassword(data));

    if (res.meta?.requestStatus === "fulfilled") {
      setOpenSuccessModal(true);
      setTimeout(() => {
        navigate("/login");
      }, 3000);
    } else if (res.meta?.requestStatus === "rejected") {
        if (res.payload?.errors) {
          setError("password", {
            type: "manual",
            message: res.payload?.errors,
          });
          }
    }
  };
  return (
    <section className="reset-pass login-page">
      <Container>
        <div className="reset-card card_holder">
          <Logo />
          <Heading
            headingText={
              <>
                SET <br />
                NEW PASSWORD
              </>
            }
          />
          <CommonText
            paraText={
              "Your new password must be Different from the previously used password."
            }
          />


          <Form className="reset-form"  onSubmit={handleSubmit(onSubmit)} >
            <Form.Group className="form-group password_holder">
              <Form.Control
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                name="password"
                {...register("password", {
                  required: "Password is required",
                  minLength: {
                    value: 8,
                    message:
                      "Password must be at least 8 characters long",
                  },
                  pattern: {
                    value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                    message:
                      "Password must contain at least one uppercase letter, one lowercase letter, and one number",
                  },
                })}
                onChange={(e) => setPassword(e.target.value)}
              />
              {errors?.password && (
                <sup className="text-danger">
                  {errors?.password?.message}
                </sup>
              )}
              <div className="eye-icc">
                <FontAwesomeIcon
                  icon={iconOne}
                  className="icon"
                  onClick={() =>
                    togglePasswordVisibility("password")
                  }
                />
              </div>
            </Form.Group>

            <Form.Group className="form-group password_holder">
              <Form.Control
                type={showPasswordOne ? "text" : "password"}
                placeholder="Confrim Password"
                name="re_password"
                {...register("re_password", {
                  required: "Re-Enter Password  is required",
                })}
                onChange={(e) =>
                  setPasswordAgain(e.target.value)
                }
              />
              <div className="eye-icc">
                <FontAwesomeIcon
                  icon={iconTwo}
                  className="icon"
                  onClick={() =>
                    togglePasswordVisibility(
                      "reenterPassword"
                    )
                  }
                />
              </div>
              {errors?.re_password && (
                <sup className="text-danger">
                  {errors?.re_password?.message}
                </sup>
              )}
              {password && (
                <PasswordChecklist
                  rules={[
                    "minLength",
                    "specialChar",
                    "number",
                    "capital",
                    "match",
                  ]}
                  minLength={8}
                  value={password}
                  valueAgain={passwordAgain}
                  onChange={(isValid) => { }}
                  style={{
                    fontSize: "10px",
                    padding: "4px",
                    margin: "0",
                  }}
                />
              )}
            </Form.Group>

            <div className="button text-center mt-4">
              <div>
                <button
                  className="reset-btn"
                  type="submit"
                  // onClick={() => setOpenSuccessModal(true)}
                >
                  Reset Password
                </button>
              </div>
            </div>
          </Form>


          <div className="home-link text-center">
            <Link to={"/login"}>
              Back
              <span>
                <i class="fa-solid fa-angle-right arrow">‌</i>
              </span>
            </Link>
          </div>
        </div>
        <div className="img-holder">
          <Banner />
        </div>
      </Container>

      {openSuccessModal && (
        <BrownSuccessFullModal
          show={openSuccessModal}
          successText="Password Reset Successfully!"
          navigateTo="/"
          onHide={() => {
            setOpenSuccessModal(false);
          }}
        />
      )}


    </section>
  );
}
